module.exports = __webpack_public_path__ + "static/media/two-books.d1710caa.png";